var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full w-full mx-auto p-6"},[_c('div',{staticClass:"bg-white shadow-lg rounded-lg w-full h-full overflow-hidden"},[_c('gallery-grid',{attrs:{"multimedia":_vm.listGalleryMultimedia}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }